import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import DashboardGridBox from '../DashboardGridBox.jsx';
import { Map } from 'immutable';
import classnames from 'classnames';
import { toCommaNumber } from '../../../utils/format';
import { memoize } from 'lodash';

class Multiples extends DashboardGridBox {
    static propTypes = {
        lines: ImmutablePropTypes.list,
        status: PropTypes.string,

        multiplesDetails: ImmutablePropTypes.list,
        multiplesDetailsStatus: PropTypes.string,

        getMultiples: PropTypes.func.isRequired,
        getMultiplesDetails: PropTypes.func.isRequired
    };

    constructor(props, context) {
        super(props, context);

        this.title = 'Multiples - risk vs payout';

        this.state = {
            opened: ''
        };

        this.columns = [
            {
                name: 'payout',
                label: 'Pot. payout',
                width: 4
            },
            {
                name: 'risk',
                label: 'Risk',
                width: 4
            },
            {
                name: 'loss',
                label: 'Exp. loss',
                width: 4
            }
        ];
    }

    UNSAFE_componentWillReceiveProps(props) {
        // Start again the updates
        // when the customer is close/minimizez
        if ( props.stopTick !== this.props.stopTick ) {
            this.startTickUpdate(props);
        }
    }

    componentDidMount() {
        this.startTickUpdate(this.props);
    }

    startTickUpdate(props) {
        clearInterval(this.refresh);

        if ( props.stopTick ) {
            return;
        }

        props.getMultiples();

        this.refresh = setInterval(() => {
            if (props.status === 'FINISHED' && !props.stopTick) {
                props.getMultiples();
            }
        }, 60000);
    }

    componentWillUnmount() {
        clearInterval(this.refresh);
    }

    onClickRedirect(data, route, event) {
        event.stopPropagation();
        event.preventDefault();

        const { eventId, marketId } = data;
        let path = '';
        let params = {
            market: parseInt(marketId, 10)
        };

        if ( route === 'liabilities') {
            path = '/trading?tab=liabilities&liabilities=both&liabilities';
            params = {
                ...params,
                event: parseInt(eventId, 10)
            };
        } else if ( route === 'market' ) {
            path = `/trading?*events=${eventId}&*events`;
            params = {
                ...params,
                tab: 'markets',
                filter: 'open'
            };
        }

        window.open(path + '.parameters=' + JSON.stringify(params));
    }

    toggleRow(selIds, event) {
        event.preventDefault();
        let isOpened = selIds === this.state.opened;

        if ( !isOpened ) {
            this.props.getMultiplesDetails(selIds.split('_'));
        }

        this.setState({
            opened: !isOpened ? selIds : null
        });
    }

    renderDropdown() {
        let { multiplesDetails, multiplesDetailsStatus } = this.props;

        return (
            <div className="multiples__dropdown">
                {
                    multiplesDetailsStatus === 'IN_PROGRESS' ?
                        <div className="spinner spinner--inline"> </div> :
                        multiplesDetails.map(line => {
                            let price = line.getIn([ 'selection', 'price' ]);
                            let priceLabel = price ? ` (${price.get('priceNum')}/${price.get('priceDen')})` : '';
                            let status = line.get('result');
                            let data = {
                                eventId: line.getIn([ 'event', 'id' ]),
                                marketId: line.getIn([ 'market', 'id' ])
                            };

                            let profit = toCommaNumber(parseInt(line.get('profitLoss'), 10));
                            let style;

                            if ( Math.sign(profit) && !status ) {
                                style = { color: 'red' };
                            }

                            return (
                                <div className="multiples__sub-item">
                                    <div className="row">
                                        <div className="col-8">
                                            <a href=""
                                               onClick={ this.onClickRedirect.bind(this, data, 'market')}>
                                                { line.getIn( [ 'selection', 'name' ]) }
                                                { !status && priceLabel }
                                            </a>
                                        </div>

                                        <div className="col-4 multiples--is-right">
                                            <a href=""
                                               style={style}
                                               onClick={ this.onClickRedirect.bind(this, data, 'liabilities')}>
                                                { status ? status : profit }
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                }
            </div>
        );
    }

    renderTable() {
        let { opened } = this.state;
        let { lines } = this.props;

        const multiplesHeader = (
            <div className="widget-table__header" key="multiples-header">
                <div className="row">
                    {
                        this.columns.map(col => {
                            return <div className={`col-${col.width}`} key={col.name}>{ col.label }</div>;
                        })
                    }
                </div>
            </div>
        );

        const multiplesRows = lines.sort((prev, next) => next.get('expLoss') - prev.get('expLoss')).map(selection => {
            let key = '';
            let selIds = [];

            let selectionNames = selection.get('selections', Map()).map(sel => {
                key += sel.get('id');

                selIds.push(sel.get('id'));

                return sel.get('name');
            }).join(', ');

            return (
                <div className={
                    classnames([ 'widget-table__row', 'multiples__item' ], {
                        'is-open': opened === selIds.join('_')
                    })}
                     onClick={this.toggleRow.bind(this, selIds.join('_'))}
                     key={ key }
                >
                    <div className="row">
                        <div className="col-12">
                            <div className="multiples__selections">
                                { selectionNames }
                            </div>
                        </div>

                        <div className="col-4">
                            <strong>{ toCommaNumber(parseInt(selection.get('potentialPayout', 0) / 100, 10) ) }</strong>
                        </div>

                        <div className="col-4">
                            <strong>{ `${ (selection.get('risk', 0) * 100).toFixed(2) }%` }</strong>
                        </div>

                        <div className="col-4 multi">
                            <strong>{ toCommaNumber(parseInt(selection.get('expLoss', 0) / 100, 10)) }</strong>
                        </div>
                    </div>

                    { this.renderDropdown(selection) }
                </div>
            );
        });

        return [ multiplesHeader, ...multiplesRows ];
    }

    renderElement() {
        const { status } = this.props;
        const count = this.props.lines.size;

        let spinner = null;
        if ( status === 'IN_PROGRESS' && count === 0 ) {
            spinner = <div className="spinner spinner--inline"> </div>;
        }

        const message = status === 'FINISHED' && count === 0 ? (
            <div className="widget-table__not-found">
                No multiples found
            </div>
        ) : null;

        return (
            <div className="multiples widget-table">
                { message }
                { spinner }
                { count ? this.renderTable() : null }
            </div>
        );
    }
}

Multiples.WIDTH = 4;
Multiples.HEIGHT = 8;
Multiples.X = 0;
Multiples.Y = 4;

export default Multiples;
